import { render, staticRenderFns } from "./MessageDetailsOverlay.vue?vue&type=template&id=f4b4d26a"
import script from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
export * from "./MessageDetailsOverlay.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailsOverlay.vue?vue&type=style&index=0&id=f4b4d26a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports